import { MinusIcon, PlusIcon } from "lucide-react";

import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";
import { Label } from "simplydo/react/ui/label";

export const CommentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 3.5px;
`;

export const CommentMain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`;

export const ThreadColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 24px;
  flex-shrink: 0;
  margin-left: 2px;
`;

export const ThreadLineSegment = styled.div`
  width: 0.5px;
  background-color: #d8d8d8;
  flex-shrink: 0;
  transform: translateX(0.5px);
  transition: background-color 0.15s ease;
`;

export const ThreadLineTop = styled(ThreadLineSegment)`
  height: 5px;
`;

export const ThreadLineBottom = styled(ThreadLineSegment)`
  flex: 1 1 auto;
  min-height: 4px;
`;

export const CollapseToggle = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 50%;
  background-color: #dadada;
  color: #fff;
  flex-shrink: 0;
  line-height: 0;
  transition: background-color 0.15s ease;
`;

export const ThreadTrack = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  width: 100%;
  min-height: 12px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  gap: 5px;

  &:hover ${ThreadLineTop},
  &:hover ${ThreadLineBottom} {
    background-color: #b0b0b0;
  }

  &:hover ${CollapseToggle} {
    background-color: #a3a3a3;
  }

  &:focus-visible {
    outline: none;
  }

  &:focus-visible ${CollapseToggle} {
    outline: 2px solid #5da2b3;
    outline-offset: 1px;
  }
`;

export const CommentBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const AuthorWithPin = styled.div`
  position: relative;
  display: inline-flex;
  min-width: 0;
`;

export const RepliesContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const CommentPinBadge = styled.div`
  position: absolute;
  top: -6px;
  left: -6px;
  z-index: 1;
  line-height: 0;
  pointer-events: none;

  ${Label} {
    font-size: 0.5em;
  }

  i {
    margin: 0 !important;
  }
`;

type ThreadCollapseControlProps = { collapsed: boolean; onToggle: () => void };

export const ThreadCollapseControl = ({
  collapsed,
  onToggle,
}: ThreadCollapseControlProps) => (
  <ThreadTrack
    type="button"
    aria-expanded={!collapsed}
    aria-label={collapsed ? "Expand thread" : "Collapse thread"}
    onClick={onToggle}
  >
    <ThreadLineTop />
    <CollapseToggle>
      <Icon
        icon={collapsed ? PlusIcon : MinusIcon}
        style={{ width: 10, height: 10, margin: 0 }}
      />
    </CollapseToggle>
    {!collapsed ? <ThreadLineBottom /> : null}
  </ThreadTrack>
);
